// extracted by mini-css-extract-plugin
export default {"content":"textarea_content__zRNTj","label":"textarea_label__SiUSk","input":"textarea_input__aYdN7","textarea":"textarea_textarea__j512i","error":"textarea_error__FDLqT"};